import React, { useEffect } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import { useSchool } from '../../DataStore/SchoolContext';
import StudentsCard from '../../components/SchoolFees/StudentsCard';
import { useTheme } from '../../DataStore/ThemeContext';
import { useStudent } from '../../DataStore/FeesStudentContext';
import Pagination from '../../components/Common/Pagination';
import AlertNotification from '../../components/Common/AlertNotification';

const ManageStudentsPage = () => {

    const {notify, syncClasses, alert, getClasses, getResidences, getFeesGroups, syncResidences, setNotify} = useSchool();
    const {openSettings} = useTheme();
    const {getStudents, mounted, setCurrentPage, metaData, selectedIds, resetSelectedIds} = useStudent();
    

    useEffect(()=>{
        getClasses();
        getResidences();
        getFeesGroups();
    }, [])

    useEffect(()=>{
        if(!mounted){
            getStudents();
        }
    }, [])

    const handleStudentSync = ()=>{
        openSettings("Sync Students", "SyncStudents", null, "Synchronize");
    }

    const handleAddToFeesGroup = () =>{
        if(selectedIds.length === 0){
            setNotify(<AlertNotification type="info" message="No student selection found. Please make selection then try again." closable={false} iconClass="fa fa-info-circle"/>);
            return;
        }
        openSettings("Assign Fees Group", "AssignFeesGroup", null, "Assign Selection");
    }

    const handleBilling = () =>{
        if(selectedIds.length === 0){
            setNotify(<AlertNotification type="info" message="No student selection found. Please make selection then try again." closable={false} iconClass="fa fa-info-circle"/>);
            return;
        }
        openSettings("Billing Preview", "BillingPreview", null, "Proceed to Bill");
    }

    const handleCustomBilling = () =>{
        if(selectedIds.length === 0){
            setNotify(<AlertNotification type="info" message="No student selection found. Please make selection then try again." closable={false} iconClass="fa fa-info-circle"/>);
            return;
        }
        openSettings("Custom Billing", "CustomBilling", selectedIds, "Proceed to Bill");
    }



    const handleDiscount = () =>{
        if(selectedIds.length === 0){
            setNotify(<AlertNotification type="info" message="No student selection found. Please make selection then try again." closable={false} iconClass="fa fa-info-circle"/>);
            return;
        }
        openSettings("Apply Fees Discount", "NewFeesDiscount", selectedIds, "Apply Discount");
    }

    const PageActions = ()=>(<>
        <ActionDropdownItem iconClass="fa fa-circle-plus text-success" label="Add to Fees Group" onClick={handleAddToFeesGroup}/>
        <ActionDropdownItem iconClass="fa-solid fa-money-bill-transfer" label="Bill Selection..." onClick={handleBilling}/>
        <ActionDropdownItem iconClass="fa-solid fa-money-bill-transfer" label="Custom Billing..." onClick={handleCustomBilling}/>
        <ActionDropdownItem iconClass="fa-solid fa-percent text-warning" label="Apply Fees discount..." onClick={handleDiscount}/>
        <ActionDropdownItem iconClass={`fa-${selectedIds.length > 0 ? 'solid' : 'regular'} fa-square-check text-primary`} label="Clear Selection..." onClick={resetSelectedIds}/>
        <ActionDropdownItem iconClass="fa fa-refresh text-success" label="Refresh" onClick={()=>getStudents(true)}/>
        <ActionDropdownItem iconClass="fa fa-server text-primary" label="Sync Students" onClick={handleStudentSync}/>
        <ActionDropdownItem iconClass="fa fa-server text-primary" label="Sync Classes" onClick={syncClasses}/>
        <ActionDropdownItem iconClass="fa fa-server text-primary" label="Sync Residences" onClick={syncResidences}/>
        </>)


    return (
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Manage Students"
                    description="Import and sync students with your students' external database."
                    iconClass="fa fa-handshake"
                    PageActions={PageActions}
                    sticky={true}
                    Pagination={metaData ? <Pagination
                        metaData={metaData}
                        onPageChange={(page) => setCurrentPage(page)}
                        loadMore={true}
                /> : <></>}
                />
                {alert}
                {notify}
                
                <StudentsCard />
               
                
            </MainContent>
        </PageContainer>
    );
};

export default ManageStudentsPage;
